import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const OvertimeCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [salary, setSalary] = useState('3.000,00');
  const [monthlyHours, setMonthlyHours] = useState('220');
  const [extraHours, setExtraHours] = useState('10');
  const [additionalRate, setAdditionalRate] = useState('50');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const s = parseFloat(parseBrazilianNumber(salary)) || 0;
    const mh = parseFloat(monthlyHours) || 0;
    const eh = parseFloat(extraHours) || 0;
    const add = parseFloat(parseBrazilianNumber(additionalRate)) / 100;
    if (s <= 0 || mh <= 0 || eh <= 0 || add < 0) return;

    const hourValue = s / mh;
    const overtimeHourValue = hourValue * (1 + add);
    const total = overtimeHourValue * eh;

    const res = { hourValue, overtimeHourValue, total };
    setResultState(res);

    onResultChange([
      { label: 'Valor Hora Normal', value: `R$ ${hourValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Valor Hora Extra', value: `R$ ${overtimeHourValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Total Horas Extras', value: `R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <FormField label="Salário (R$)" value={salary} onChange={setSalary} required isNumeric type="text" />
          <FormField label="Horas/mês" value={monthlyHours} onChange={setMonthlyHours} required isInteger type="text" helpText="Padrão CLT: 220" />
          <FormField label="Horas Extras" value={extraHours} onChange={setExtraHours} required isInteger type="text" />
          <FormField label="Adicional (%)" value={additionalRate} onChange={setAdditionalRate} required isNumeric type="text" helpText="50% ou 100%" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Hora Extra
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Hora Normal" value={`R$ ${resultState.hourValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="slate" />
            <ResultCard title="Hora Extra" value={`R$ ${resultState.overtimeHourValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Total" value={`R$ ${resultState.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Regras para Cálculo de Horas Extras"
        tips={[
          'O valor da hora extra deve ser, no mínimo, 50% superior à hora normal',
          'Trabalho em feriados ou domingos geralmente tem adicional de 100%',
          'Valor da hora normal = Salário mensal / Carga horária mensal',
          'Sobre o valor das horas extras também incide o DSR (Descanso Semanal Remunerado)'
        ]}
      />
    </div>
  );
};

export default OvertimeCalculator;
